import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useActiveLocale } from '../i18n/hooks';
import {
  LOCALE_LABELS,
  SupportedLocale,
  buildLocalePath,
  stripLocaleFromPath
} from '../i18n/routing';

function LanguageSwitcher() {
  const locale = useActiveLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (eventKey: string | null) => {
    if (!eventKey) {
      return;
    }
    const nextLocale = eventKey as SupportedLocale;
    const { path } = stripLocaleFromPath(location.pathname);
    navigate(`${buildLocalePath(nextLocale, path)}${location.search}`, { replace: true });
  };

  return (
    <NavDropdown
      id="language-switcher"
      title={LOCALE_LABELS[locale]}
      onSelect={handleSelect}
      align="end"
    >
      {Object.entries(LOCALE_LABELS).map(([key, label]) => (
        <NavDropdown.Item key={key} eventKey={key} active={key === locale}>
          {label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}

export default LanguageSwitcher;
